import { useLanguageRegionCode } from './useLanguageRegionCode';

export function useCountryCode() {
  const languageRegionCode = useLanguageRegionCode();
  return languageRegionCode.split('-')[1] as 'DK' | 'NL' | 'US' | 'GB' | 'FR' | 'DE' | 'IT' | 'NO' | 'PL' | 'PT' | 'BR' | 'ES' | 'MX' | 'SE';
}
